import VerticalNavMenuLink from '@src/components/layouts/components/menu/vertical-menu/VerticalNavMenuLink';
import {
  getPath,
  ROUTE_ADMIN_GIFT_CARD_DESIGNS,
  ROUTE_ADMIN_PAYMENT_HISTORY,
  ROUTE_ADMIN_REFUNDS,
  ROUTE_COMPANIES,
    ROUTE_ADMIN_STUCK_RESERVATIONS,
} from '@src/@data/router/consts';
import { useMessages } from '@src/@data/utility/hooks/useMessages';
import { useAuth } from '@src/@data/store/AuthProvider';
import {DollarSign, FileText, Gift, Pause} from 'react-feather';
import ScrollBar from 'react-perfect-scrollbar';
import { Link } from 'react-router-dom';

export const AdminMenu = () => {
  const { messages } = useMessages();
  const { isAdminBooklaUser } = useAuth();
  return (
    <>
      <div className="main-menu-header ml-1 mr-1 mt-1">
        <Link
          to={getPath(ROUTE_COMPANIES, { companyId: '' })}
          className="btn btn-primary w-100"
        >
          {messages('admin_menu_homepage_cta')}
        </Link>
      </div>
      <hr />
      <ScrollBar
        className="main-menu-content"
        options={{ wheelPropagation: false }}
      >
        <ul className="navigation navigation-main mb-2">
          {isAdminBooklaUser && (
            <>
              <VerticalNavMenuLink
                title={messages('nav_menu_gift_card_designs')}
                icon={Gift}
                navLink={ROUTE_ADMIN_GIFT_CARD_DESIGNS}
              />
              <VerticalNavMenuLink
                title={'Payment History'}
                icon={FileText}
                navLink={ROUTE_ADMIN_PAYMENT_HISTORY}
              />
              <VerticalNavMenuLink
                title={'Refunds'}
                icon={DollarSign}
                navLink={ROUTE_ADMIN_REFUNDS}
              />
              <VerticalNavMenuLink
                title={'Stuck paid reservations'}
                icon={Pause}
                navLink={ROUTE_ADMIN_STUCK_RESERVATIONS}
              />
            </>
          )}
        </ul>
      </ScrollBar>
    </>
  );
};
